export default () => {
    $(function() {
        $('.js-select-estimation-type')
            .on('change', 'input[name=printing_category]', function (e) {
                var $block = $(this).closest('.js-select-estimation-type');
                var enableColorChange = $(this).data('colorChange').toString() === "1";

                $block.find('.js-estimate-types-note-wrap').toggle(enableColorChange);
                $block.find('.js-estimate-type-color-change')
                    .css('visibility', enableColorChange ? 'visible' : 'hidden');
            })
            .on('click', 'a.js-estimate-type-link', function (e) {
                var $block = $(this).closest('.js-select-estimation-type');
                var value = $block.find('input[name=printing_category]').filter(':checked').val();
                if (!value) {
                    return false;
                }

                location.href = $(this).data('href') + '&printing_category=' + value;

                return false;
            });

        $('.js-select-estimation-type input[name=printing_category]:checked').trigger('change');
    });
};
